export default __webpack_public_path__ + "static/media/LOGOAuto.e90898f0.svg";